import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { ProductGrid } from '../components/ProductGrid';
export function OTCProducts() {
  const {
    storeId
  } = useParams();
  const [searchParams] = useSearchParams();
  const searchQuery = searchParams.get('search') || '';
  return <div className="bg-white" data-id="element-291">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 sm:pt-20" data-id="element-292">
        <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900 mb-4 uppercase tracking-tighter" data-id="element-293">
          {searchQuery ? `Search Results` : `Over-the-Counter Products`}
        </h1>
        <p className="text-base sm:text-lg text-slate-600 mb-4 max-w-3xl" data-id="element-294">
          {searchQuery ? `Showing results for "${searchQuery}"` : `Browse our full selection of quality health and wellness products.`}
        </p>
      </div>
      <ProductGrid storeId={storeId} searchQuery={searchQuery} data-id="element-295" />
    </div>;
}